import React, { useState, useEffect, useRef } from "react";
import logoSrc from '../img/logo.png'; // Assuming logo.png is in the img folder
import './Contracting.css'; // Assuming the CSS is in the same directory
import ContactForm from '../ContactForm'; // Make sure this component has the `openForm` method.
const App = () => {


 const contactFormRef = useRef(); // Reference for controlling the contact form

  // Function to open the contact form
  const handleOpenContactForm = () => {
    if (contactFormRef.current) {
      contactFormRef.current.openForm(); // Ensure the `ContactForm` has this method.
    }
  };

  const [activeSection, setActiveSection] = useState("terms");
  const [isFooterVisible, setIsFooterVisible] = useState(false); // New state for detecting footer visibility

  const sections = [
    {
      id: "terms",
      label: "Terms",
      content: (
        <div className="app-content-section">
          <h2 className="app-content-title">Terms and Conditions</h2>
          <h3 className="app-content-subtitle">Introduction</h3>
          <p className="app-content-paragraph">
            Welcome to Shigjeta LLC, a creative agency and experience design company located at Ismail Raka BLVD, Kacanik, Kosovo. By accessing or using our website (shigjeta.com), subdomains, email communications, pages, chats, links, or any associated content, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
          </p>

          <h3 className="app-content-subtitle">Business Activities</h3>
          <p className="app-content-paragraph">
            <strong>1. Services Provided:</strong> Shigjeta LLC offers a variety of services including but not limited to creative design, experience design, content creation, branding, web development, and marketing strategy. Our services cater to a diverse range of industries and clients.
          </p>

          <h3 className="app-content-subtitle">Content Deployment and Use</h3>
          <p className="app-content-paragraph">
            <strong>2. Content Ownership:</strong> All content, including but not limited to text, graphics, logos, images, videos, and software, deployed, tested, or implemented by Shigjeta LLC is the intellectual property of Shigjeta LLC unless otherwise stated. Unauthorized use of our content is prohibited.
          </p>
          <p className="app-content-paragraph">
            <strong>3. Content Licensing:</strong> If you intend to use any content from our website or associated platforms, you must notify us and obtain our written consent. Proper credit must be given to Shigjeta LLC for any content used. We reserve the right to revoke or modify licenses at any time.
          </p>
          <p className="app-content-paragraph">
            <strong>4. Client Contributions:</strong> Any content contributed by clients or users, such as user-generated content, comments, or reviews, remains the property of the contributor. However, by submitting such content, you grant Shigjeta LLC a worldwide, royalty-free, perpetual, and non-exclusive license to use, reproduce, modify, and distribute the content.
          </p>
        </div>
      )
    }
  ];

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY + window.innerHeight / 2;

      // Check if the footer with the ID 'footerElements' is in view
      const footer = document.getElementById("footerElements");
      const footerPosition = footer ? footer.offsetTop : 0;
      const footerHeight = footer ? footer.offsetHeight : 0;

      if (currentScroll + window.innerHeight >= footerPosition) {
        setIsFooterVisible(true);
      } else {
        setIsFooterVisible(false);
      }

      // Determine active section
      const sectionOffsets = sections.map((section) => {
        const element = document.getElementById(section.id);
        return {
          id: section.id,
          offsetTop: element.offsetTop,
          offsetBottom: element.offsetTop + element.offsetHeight,
        };
      });

      // Find the active section based on scroll position
      const active = sectionOffsets.find(
        (section) =>
          currentScroll >= section.offsetTop &&
          currentScroll <= section.offsetBottom
      );

      // Only update the activeSection if it changes
      if (active && active.id !== activeSection) {
        setActiveSection(active.id);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [sections, activeSection]);

  return (
    <>
     
      {/* Hero Section */}
      <div className="banner-logo" id="sectionBanner1">
        {logoSrc && <img src={logoSrc} alt="Shigjeta Logo" />}
      </div>
      
      <section className="banner-section" id="sectionBanner">
        <div className="banner-container">
          <div className="banner-text">
          <h1 className="banner-title" id="titulli">building trust and transparency.</h1>
            <p className="banner-description">
            Tailored solutions for global impact—driving success through market understanding, innovation, and sustainable growth
            </p>
            <a
              onClick={handleOpenContactForm} // Open the form on button click
              className="banner-button"
            >
              Start Now
            </a>

          </div>
          <div className="shop-hero-background"></div>
        </div>
      </section>
      <div className='img-background'>
      <img
              className="img"
              id='banner1-video'
              src="/img/Contracting Thumbnail.png"  // This should be correct if the video is in the public folder
              autoPlay
              muted
              loop
              playsInline
              onError={(e) => console.error('Error loading video:', e)}  // Error logging for debugging
            />
      </div>


      <div className="App">
        {/* Navigation Circles */}
        <nav className={`app-circle-nav ${isFooterVisible ? "stop" : ""}`}>
          {sections.map((section, index) => {
            const isPast = sections
              .slice(0, sections.findIndex((s) => s.id === activeSection))
              .map((s) => s.id)
              .includes(section.id);

            return (
              <div
                key={section.id}
                className={`app-circle ${activeSection === section.id ? "pulse" : isPast ? "past" : ""}`}
                onClick={() =>
                  document.getElementById(section.id).scrollIntoView({ behavior: "smooth" })
                }
              >
                {section.label}
              </div>
            );
          })}
        </nav>

        {/* Sections */}
        <main className="sections">
          {sections.map((section) => (
            <section key={section.id} id={section.id} className="section">
              <h1>{section.label}</h1>
              <div>{section.content}</div>
            </section>
          ))}
        </main>
      </div>
      <ContactForm ref={contactFormRef} />
    </>
  );
};

export default App;
